import "core-js/es6/map";
import "core-js/es6/set";
import "raf/polyfill";

import React from "react";
import ReactDOM from "react-dom";
import {
  withRouter,
  Switch,
  Link,
  BrowserRouter as Router,
  Route
} from "react-router-dom";
import "./Styles/bootswatchsuperhero.css";
import "./index.css";

import NavMenu from "./Components/Nav/Nav.js";
import App from "./Components/App/App.js";
import Samtykke from "./Components/App/Samtykke.js";
import Food from "./Components/Food/Food.js";
import Info from "./Components/Info/Info.js";
import Music from "./Components/Music/Music.js";
import Signup from "./Components/Signup/Signup.js";
import ReadOnlySeatmap from "./Components/Signup/ReadOnlySeatmap.js";
import Compo from "./Components/Compo/Compo.js";
import FadeIn from "react-fade-in";

import Admin from "./Components/Admin/Admin";
import Login from "./Components/Auth/Login";

import Contact from "./Components/Contact/Contact.js";
import Surprise from "./Components/Surprise/Surprise.js";
import glLogo from "./GAMERLAN_preview.png";
import PaymentInfo from "./Components/Signup/PaymentInfo";
import Salgsbetingelser from "./Components/Info/betingelser";
import ProtectedRoute from "./Components/Auth/ProtectedRoute.js";

import NavBurger from "./Components/Nav/NavBurger.js";

// eslint-disable-next-line
import TestSignup from "./Components/Signup/TestSignup";
// eslint-disable-next-line

import registerServiceWorker from "./registerServiceWorker";

// Import custom auth provider
import { AuthProvider } from "./Components/Admin/AuthContext.js"; 

export class Index extends React.Component {
  render() {
    return (
     
        <FadeIn>
          <div className="BodyWrapper">
            <div className="NavFiller">
              <div className="MenuMargin" />
            </div>
            <AuthProvider>
            <Router>
              <div>
                <header className="App-header">
                  <img src={glLogo} className="App-logo" alt="logo" />
                </header>

                <NavBurger />
                <div className="row BodyContent">
                  <div className="col-sm-1 NavContent">
                    <Switch>
                      <NavMenu className="Nav" id="Nav" />
                    </Switch>
                  </div>
                  <div className="col-md-10 AppContent">
                    <Switch>
                      <Route path="/compo*" component={Compo} />
                      <ProtectedRoute path="/admin" component={Admin} />
                      <Route path="/login" component={Login} />
                      <Route path="/signup" component={Signup} />
                      <Route path="/påmelding" component={Signup} />
                      <Route path="/staticSeatmap" component={ReadOnlySeatmap} />
                      <Route path="/music" component={Music} />
                      <Route path="/food" component={Food} />
                      <Route path="/info" component={Info} />
                      <Route path="/contact" component={Contact} />
                      <Route path="/app" component={App} />
                      <Route path="/surprise" component={Surprise} />
                      <Route path="/samtykkeskjema.pdf" component={Samtykke} />
                      <Route path="/samtykkeskjema" component={Samtykke} />
                      <Route path="/betaling" component={PaymentInfo} />
                      <Route path="/betingelser" component={Salgsbetingelser} />
                      <Route path="/" component={App} />
                    </Switch>
                  </div>
                </div>
                <Link to="/admin">
                  <button className="hiddenButton"></button>
                </Link>
              </div>
            </Router>
            </AuthProvider>
          </div>
        </FadeIn>
    );
  }
}

export default withRouter(Index);

ReactDOM.render(<Index />, document.getElementById("root"));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js